import {
  getErpTranslationNamespace,
  type GetErpTranslationNamespaceProps,
} from "src/system/getErpTranslationNamespace.ts";
import { loadTranslations } from "src/lib/i18next/loadTranslations.ts";

export type LoadErpTranslationProps = GetErpTranslationNamespaceProps;

export const loadErpTranslations = (props: LoadErpTranslationProps) => {
  const namespaces = getErpTranslationNamespace(props);
  return loadTranslations(namespaces);
};
